import React, { useReducer, useEffect, useContext, useRef} from "react";
import nivel5Context from "./nivel5Context";
import { getAllNivel5s, addNivel5, updateNivel5, deleteNivel5, updatePositioning, deleteNivel5AndChildren } from "../../api/nivel5";
import nivel5Reducer from "./nivel5Reducer";
import authContext from "../authentication/authContex";


//Types
import { 
    ACTUALIZAR_LIST_NIVEL5,
  } from "./nivel5Actions";
import { SocketContext } from "../socket/socket";
import Swal from "sweetalert2";


const Nivel5State = props =>{
    
    const initialState = {
        nivel5List: null
     };
    
    const [state, dispatch] = useReducer(nivel5Reducer, initialState);
    
    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;
    const server = useContext(SocketContext);
    const nivel5ListRef = useRef(state.nivel5List);

    const actualizarNivel5List = async () => {
        try{
            const resp = await getAllNivel5s();
            let nivel5 = resp.data.data;
            nivel5 = nivel5.map((lv5,i) => ({...lv5, position: lv5.position ?? i + 1})); 
            nivel5ListRef.current = nivel5;
            dispatch({
                type: ACTUALIZAR_LIST_NIVEL5,
                payload: nivel5
            });
            
            return nivel5;
        }catch(err){
            console.log(err)
        }
    };

    const agregarNivel5 = async (datos) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addnivel5
            const resp = await addNivel5(datos);
            const nivel5 = resp.data.data;
            return {saved:true, lv5Saved: nivel5};
        }catch(err){
            console.log("err en agregarNivel5");
            console.log(err);
            let msg = err.response?.data?.message ?? 'Error desconocido'
            let customMsg = msg.includes("duplicate key error") ? 'Código o Nombre se está repitiendo.' : msg;
            return {saved: false, msg: customMsg};   
        }   
    };

    const modificarNivel5 = async (dato) => {
        try{
            
            const resp = await updateNivel5(dato);
            const activo = resp.data.data;
            
            return activo;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarNivel5 = async (id) => {
        try{
            const resp = await deleteNivel5(id);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarNivel5eHijos = async(id, deleteActivesToo = false, from = '') => {
        try {

            const resp = await deleteNivel5AndChildren(id, deleteActivesToo);
            const nivel5 = resp.data.data;
            const swalConfig = {title:'Eliminado!', html: nivel5, icon:'success'};
            if(from === 'TreeActivo') return swalConfig;
            Swal.fire(swalConfig);
            return nivel5;
        } catch (error) {
            console.log(error)
            const errorConfig = {title:'Ops!', text: error?.response?.data?.data ?? 'Error al eliminar', icon:'error'};
            if(from === 'TreeActivo') return errorConfig;
            if(error.response?.status == 401) Swal.fire(errorConfig);
        }
    }

    const updatePositionLv5 = async (updates) => {
        let lvs5Updated = nivel5ListRef.current ?? [];
        lvs5Updated = lvs5Updated.map(a => {
            let lvFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: lvFound ? lvFound.position : a.position
            }
        });
        nivel5ListRef.current = lvs5Updated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_NIVEL5,
            payload: lvs5Updated
        });
    }

    useEffect(() => {
        if(usuario != null) actualizarNivel5List();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('nivel5sUpdated', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server nivel5sUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel5List();
                }
            });

            server.on('nivel5Eliminated', ({tenantId}) => {
                let update = verificarTenant(tenantId);
                if(update){
                    actualizarNivel5List();
                }
            })

            return () => {
                server.off('nivel5sUpdated');
                server.off('nivel5Eliminated');
            }
        }
    },[server])

    return(
        <nivel5Context.Provider
            value={{
                nivel5List: state.nivel5List,
                actualizarNivel5List,
                agregarNivel5,
                modificarNivel5,
                eliminarNivel5,
                eliminarNivel5eHijos,
                updatePositionLv5
            }}
        >
            {props.children}
        </nivel5Context.Provider>
    )

}

export default Nivel5State;